import { useCallback, useEffect } from 'react';

import { useMutation } from '@apollo/client';

import { useAuth } from '../../../context/Auth';

import { WALLET_CONNECT } from '../../../http/apollo-queries';
import { logger } from '../../../helpers/logger';

export const WalletConnect = ({
  strategyId,
  onCompleted,
  onError,
}: {
  strategyId: string;
  onCompleted(d: any): void;
  onError(error: Error): void;
}) => {
  const { user } = useAuth();
  const { profile } = user!;
  const { id: profileId } = profile!;

  const [walletConnect] = useMutation(WALLET_CONNECT, {
    onCompleted,
    onError,
  });

  const connect = useCallback(
    (provider: string) => {
      logger.log('WalletConnect:strategyId', strategyId);
      walletConnect({
        variables: {
          provider,
          profileId,
          language: 'EN',
        },
      });
    },
    [profileId, walletConnect]
  );

  sessionStorage.setItem('walletStrategyId', strategyId);

  useEffect(() => {
    connect('');
  }, []);

  logger.log('WalletConnect:strategyId', strategyId);
  return <></>;
};
